import { assignSafe } from '@summit/core';
export class PasswordValidation {
  password?: string;
  clientActions?: string;

  constructor(jsonData?: any) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
  }
}
